'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.env = env;
exports.isURL = isURL;
exports.setTitleWechat = setTitleWechat;
exports.getSharePlatform = getSharePlatform;
/**
 * 获取当前环境
 * @return {String} 环境值
 */
function env() {
  if (typeof window === 'undefined') {
    return 'node';
  }

  var UA = window.navigator.userAgent.toLowerCase();

  if (UA.match(/MicroMessenger/i)) {
    return 'wechat';
  }
  if (UA.match(/ZhongAnWebView/i)) {
    return 'za';
  }
  if (UA.match(/ifuli/i)) {
    return 'ifuli';
  }
  if (UA.match(/iyunbao/i)) {
    return 'iyunbao';
  }
  return 'browser';
}

/**
 * 判断是不是带协议的网址（//开头或者包含://）
 * @param {Boolean}   
 */
function isURL(url) {
  return (/^\/\//.test(url) || /^[a-zA-z]+:\/\/[^\s]*/.test(url)
  );
}

/**
 * 设置标题微信
 * @param {String} title 数据
 */
function setTitleWechat(title) {
  document.title = title;
  var iframe = document.createElement('iframe');
  iframe.src = '/favicon.ico';
  iframe.style.display = 'none';
  iframe.onload = function () {
    setTimeout(function () {
      iframe.remove();
    }, 0);
  };
  document.body.appendChild(iframe);
}

/**
 * 获取分享
 * @param {Object} table 默认数据
 * @param {Object} value 数据
 */
function getSharePlatform(table, value) {
  var platform = (value || []).map(function (item) {
    return table[item];
  });
  return platform.join(',');
}